import { EventOptions, TrackingProperties } from './trackerTypes'

// Symbol to use as a key to store in the type the available tracking properties
const typedEventPropertiesSymbol = Symbol('typedEventProperties')
type ShadowTypedEventPropertiesType<P extends TrackingProperties | never> = {
  [typedEventPropertiesSymbol]: P
}

/**
 * Makes a typed event, which declares a strict list of properties
 */
export const makeTypedEvent = <P extends TrackingProperties | never = never>(
  event: string
): string & Partial<ShadowTypedEventPropertiesType<P>> => {
  return event
}

type TypedEventProperties<T> =
  Required<T> extends ShadowTypedEventPropertiesType<TrackingProperties>
    ? Required<T>[typeof typedEventPropertiesSymbol]
    : never

type TrackParams<T> = typeof typedEventPropertiesSymbol extends keyof T
  ? [TypedEventProperties<T>] extends [never]
    ? [parameters?: Record<string, never>, eventOptions?: EventOptions]
    : [parameters: TrackingProperties, eventOptions?: EventOptions]
  : [parameters?: TrackingProperties, eventOptions?: EventOptions]

/**
 * Function that tracks an event, while strictly checking its parameters
 */
export type TypedTrack = <T extends string>(event: T, ...params: TrackParams<T>) => Promise<boolean>
